import { useMemo, useRef } from 'react';
import { Field } from '@shopify/react-form';
import gettext, { pgettext } from '@sdk/lang/gettext';
import { usePersonaCollection } from '@sdk/personaCollection/PersonaCollectionContext';
import { PersonaPickerOption } from '@sdk/components/forms/personaPickers/PersonaPicker/personaPicker.types';
import { GroupedPersonaPicker } from '@sdk/components/forms/personaPickers/GroupedPersonaPicker/GroupedPersonaPicker';

import ModalRow from '@web/timesheets/CreateTimesheetModal/components/rows/ModalRow/ModalRow';
import {
  FieldContainer,
  EllipsisContainer,
} from '@web/timesheets/CreateTimesheetModal/components/rows/ModalRow/modalRow.styles';
import { getEmployeeOptions } from '@web/timesheets/CreateTimesheetModal/components/rows/EmployeeRow/employeeRow.utils';
import EmployeeIconSvg from '@web/assets/svg/Icons/32/user-gray.svg';

type Props = {
  employeeField: Field<PersonaPickerOption[]>;
  onChange: (employees: IDObject[]) => void;
};
const EmployeeRow = ({ employeeField, onChange }: Props) => {
  const fieldRef = useRef<HTMLInputElement>(null);
  const personaCollection = usePersonaCollection();
  const options = useMemo(
    () => getEmployeeOptions(personaCollection.users),
    [personaCollection.users]
  );
  return (
    <ModalRow label={gettext('Employee')} icon={EmployeeIconSvg}>
      <EllipsisContainer ref={fieldRef} width={fieldRef?.current?.offsetWidth}>
        <FieldContainer>
          <GroupedPersonaPicker
            onSelectedItemsChange={onChange}
            options={options}
            selectedItems={employeeField.value}
            placeholder={pgettext('Always singular', 'Add employee')}
            showTagIcons
            showSearchIcon={false}
            maxItemsToSelect={1}
            hasError={Boolean(employeeField.error?.length)}
          />
        </FieldContainer>
      </EllipsisContainer>
    </ModalRow>
  );
};

export default EmployeeRow;
